<template>
  <div style="textAlign:right">
    <a-button style="width:100%" class="submit-audit" @click="emitEvent">{{instance.btName}}</a-button>
  </div>
</template>

<script>
export default {
  props: {
    instance: Object
  },
  data() {
    return {

    }
  },
  methods: {
    emitEvent() {
      this.$emit(this.instance.cb)
    }
  }
}
</script>
